"use client";

import { useEffect, useRef, useState } from "react";
import { HiOutlineMenu } from "react-icons/hi";

import BookingLink from "@/components/shared/booking-link/BookingLink";
import type { TourPageThemeKey } from "@/components/sections/tour-page/types";
import { getTourChromeStyles } from "@/components/layout/tourChromeStyles";
import MobileMenu from "./MobileMenu";

export default function MobileMenuControls({
  isGhostPage = false,
  tourTheme,
  bookingHref,
}: {
  isGhostPage?: boolean;
  tourTheme?: TourPageThemeKey;
  bookingHref: string;
}) {
  const chrome = getTourChromeStyles(tourTheme, isGhostPage).header;
  const [isOpen, setIsOpen] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  const buttonRef = useRef<HTMLButtonElement>(null);
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const resetOpenSections = () => {
    dialogRef.current
      ?.querySelectorAll<HTMLDetailsElement>("details[open]")
      .forEach((detailsElement) => {
        detailsElement.removeAttribute("open");
      });
  };

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDialogClose = () => {
    setIsOpen(false);
    resetOpenSections();
    buttonRef.current?.focus();
  };

  return (
    <>
      <div className="col-start-3 flex justify-self-end gap-3 xl:hidden">
        <BookingLink
          href={bookingHref}
          target="_blank"
          rel="nofollow noopener"
          className={`inline-flex h-12 shrink-0 items-center justify-center whitespace-nowrap rounded-none ${chrome.mobileBookingCta} px-1 text-sm font-semibold uppercase transition-colors min-[360px]:px-5 sm:px-10`}
        >
          Book Now
        </BookingLink>

        <button
          ref={buttonRef}
          type="button"
          id="menuButton"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          aria-controls="mobile-sliding-menu"
          disabled={!isHydrated}
          onClick={handleToggle}
          className={`border ${chrome.mobileMenuButton} p-2 transition-colors`}
        >
          <HiOutlineMenu
            size="30px"
            color={chrome.mobileMenuIconColor}
          />
        </button>
      </div>

      {isOpen ? (
        <div aria-hidden="true" data-mobile-menu-open className="hidden" />
      ) : null}

      <MobileMenu
        isGhostPage={isGhostPage}
        tourTheme={tourTheme}
        isOpen={isOpen}
        handleClose={handleClose}
        dialogRef={dialogRef}
        handleDialogClose={handleDialogClose}
      />
    </>
  );
}
